import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { InnerGlowLogo } from "./InnerGlowLogo";

export const Contact = () => {
  const year = new Date().getFullYear();

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative w-full pt-28 md:pt-36 border-t border-border bg-background"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 md:gap-10 mb-12 md:mb-14">
          <div className="col-span-12 md:col-span-3 flex md:items-end reveal">
            <span className="font-sans text-[11px] uppercase tracking-[0.4em] text-[hsl(var(--accent))] font-light">
              Contact
            </span>
          </div>
          <div className="col-span-12 md:col-span-9 reveal">
            <p className="font-sans text-foreground/70 text-xl md:text-2xl max-w-2xl leading-snug font-light">
              For documentary production, news field support, event coverage
              or custom video projects — get in touch to discuss your story,
              schedule and production needs.
            </p>
          </div>
        </div>

        <div className="border-t border-border pt-10 md:pt-14 pb-8 reveal">
          <div className="font-sans text-[11px] uppercase tracking-[0.32em] text-muted-foreground mb-5 font-light">
            Write to us
          </div>
          <a
            href="mailto:innerglowprod@gmail.com"
            data-testid="contact-email-link"
            className="group inline-flex items-baseline flex-wrap"
          >
            <span className="font-display font-extralight tracking-tighter leading-[0.95] text-foreground text-[10vw] md:text-[6.5vw] lg:text-[5vw] break-all">
              innerglowprod<span className="text-foreground/65">@gmail.com</span>
            </span>
            <ArrowUpRight
              size={36}
              strokeWidth={1}
              className="ml-2 md:ml-3 text-[hsl(var(--accent))] -translate-y-1 md:-translate-y-2 transition-transform duration-500 group-hover:translate-x-2 group-hover:-translate-y-2"
            />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 border-t border-border pt-10 pb-20 md:pb-24">
          <div className="md:col-span-4 reveal">
            <div className="font-sans text-[11px] uppercase tracking-[0.32em] text-muted-foreground mb-3 flex items-center gap-2 font-light">
              <Phone size={12} strokeWidth={1.5} />
              <span>Telephone</span>
            </div>
            <a
              href="tel:+972547444325"
              data-testid="contact-phone-link"
              className="link-line font-sans text-xl md:text-2xl text-foreground font-light"
            >
              +972 54-744-4325
            </a>
          </div>

          <div className="md:col-span-4 reveal">
            <div className="font-sans text-[11px] uppercase tracking-[0.32em] text-muted-foreground mb-3 flex items-center gap-2 font-light">
              <MapPin size={12} strokeWidth={1.5} />
              <span>Based in</span>
            </div>
            <div data-testid="contact-location-text" className="font-sans text-xl md:text-2xl text-foreground font-light">
              Israel
            </div>
            <div className="font-sans text-sm text-muted-foreground mt-2 font-light">
              Available worldwide for assignment.
            </div>
          </div>

          <div className="md:col-span-4 flex md:justify-end md:items-end reveal">
            <a
              href="mailto:innerglowprod@gmail.com"
              data-testid="contact-cta-btn"
              className="inline-flex items-center gap-3 px-8 h-14 bg-foreground text-background font-sans uppercase text-[11px] tracking-[0.32em] hover:bg-[#C5A059] hover:text-black transition-colors font-medium"
            >
              <Mail size={14} strokeWidth={1.5} />
              Start a Conversation
            </a>
          </div>
        </div>
      </div>

      <footer className="border-t border-border">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-7 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <InnerGlowLogo />
          <div data-testid="footer-copyright" className="font-sans text-[11px] uppercase tracking-[0.32em] text-muted-foreground font-light">
            © {year} InnerGlow Productions — All rights reserved.
          </div>
          <div className="font-sans text-[11px] uppercase tracking-[0.32em] text-muted-foreground font-light">
            Gregory Bado · Director
          </div>
        </div>
      </footer>
    </section>
  );
};
